function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent, computed } from "vue";
import { handleDownloadConfig } from "../config/dialog";
import { getFileExtension } from "@com/utils/file";
import { targetUrl } from "../config/form";
import { fmtSize } from "@com/utils/data-format";
import { TabsType } from "../config/enums";
import { SkeletonType } from "@com/enums/model";
import store from "@/store";
export default defineComponent({
    name: "confirm-dialog",
    props: {
        id: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var handleClose = function handleClose() {
            store.commit("resource/updateViewDialog", {
                visible: false
            });
        };
        var resource = computed(function() {
            return store.state.resource;
        });
        var dialogVisible = computed({
            get: function() {
                return resource.value.viewDialog.visible;
            },
            set: function(val) {
                store.commit("resource/updateViewDialog", {
                    visible: val
                });
            }
        });
        var viewModelInfo = computed(function() {
            return resource.value.viewDialog;
        });
        var modelId = computed(function() {
            return viewModelInfo.value.id;
        });
        var getFormat = computed(function() {
            var formatList = (viewModelInfo.value.file_list || []).filter(function(file) {
                return getFileExtension(file.name) === "glb" || getFileExtension(file.name) === "gltf";
            });
            if (formatList.length) {
                return getFileExtension(formatList[0].name);
            }
            return "-";
        });
        var previewUrl = computed(function() {
            var url1 = "";
            var textureQuery = "";
            if (viewModelInfo.value.type === TabsType.ACTION) {
                // 动作预览
                var animationURL = encodeURIComponent((viewModelInfo.value.preview_urls || []).find(function(url) {
                    return getFileExtension(url) === "glb";
                }) || "");
                var _obj;
                var modelURLMap = (_obj = {}, _defineProperty(_obj, SkeletonType.HUMANOID, "human/Suit.glb"), _defineProperty(_obj, SkeletonType.REPTILIA, "reptiles/dog01.glb"), _defineProperty(_obj, SkeletonType.FISH, "fish/ClownFish.glb"), _defineProperty(_obj, SkeletonType.SNAKE, "snake/Snake.glb"), _defineProperty(_obj, SkeletonType.SIMPLE, "monster01/monster01.glb"), _obj);
                var modelURL = modelURLMap[viewModelInfo.value.skeleton_type] || "human/Suit.glb";
                url1 = "action=loadModel&modelURL=../../model/".concat(modelURL).concat(textureQuery, "&animationURL=").concat(animationURL);
            } else if (viewModelInfo.value.type === TabsType.MODEL) {
                // 模型预览
                var modelUrl = (viewModelInfo.value.preview_urls || []).find(function(url) {
                    return getFileExtension(url) === "glb" || getFileExtension(url) === "gltf";
                }) || "";
                url1 = "action=loadModel&modelURL=".concat(modelUrl).concat(textureQuery);
            }
            return "".concat(targetUrl(), "?").concat(url1);
        // const modelUrl =
        //   (resource.value.viewDialog.preview_urls || []).find((url: string) => {
        //     return (
        //       getFileExtension(url) === 'glb' || getFileExtension(url) === 'gltf'
        //     )
        //   }) || ''
        // const textureURL =
        //   (resource.value.viewDialog.preview_urls || []).filter((url: string) => {
        //     return (
        //       !getFileName(url).includes('_hsvMask') &&
        //       (getFileExtension(url) === 'jpg' || getFileExtension(url) === 'png')
        //     )
        //   }) || []
        // const textureQuery = ''
        // if (textureURL.length) {
        //   textureURL.forEach((url) => {
        //     textureQuery += `&textureURL=${url}`
        //   })
        // }
        // return `${targetUrl()}?action=loadModel&modelURL=${modelUrl}${textureQuery}`
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: "\u8BE6\u60C5",
                width: "30%",
                fullscreen: true
            }, attrs);
        });
        return {
            previewUrl: previewUrl,
            dialogVisible: dialogVisible,
            modelId: modelId,
            viewModelInfo: viewModelInfo,
            getFormat: getFormat,
            dialogAttrs: dialogAttrs,
            TabsType: TabsType,
            fmtSize: fmtSize,
            handleClose: handleClose,
            handleDownloadConfig: handleDownloadConfig
        };
    }
});
